module.exports = __webpack_public_path__ + "static/media/logo-mediasoft-mobile.b8375be3.svg";